import React from "react";
import Aux from "../utils/AuxFunctions";
// import "./Register.css"
import "./Account.css"
import Fire from "../config/Fire";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import Colors from "../utils/Colors";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import FacebookIcon from 'mdi-react/FacebookIcon';
import GoogleIcon from 'mdi-react/GoogleIcon';
import { Link } from "react-router-dom";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";

const promoCodes = [
    
    {code:"97a224", reward:25},
    {code:"2ba8ee", reward:50},
    {code:"b9f911", reward:100},
    {code:"715b88", reward:200},
    {code:"a8808d", reward:500},
    {code:"4c67d7", reward:750},
    {code:"28e81c", reward:1000},
    {code:"46ea44", reward:2500},
    {code:"f969f2", reward:5000},
    {code:"e7690c", reward:10000},

]

class Register extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            email: "",
            password: "",
            confirmPassword: "",
            isLoading: false,
            error: "",
            facebookLoading: false,
            googleLoading: false,
            errorPassword: "",
            errorUsername: "",
            errorEmail: "",

            invitationReward:"",
        }
    }

    componentDidMount() {
        try {
            if(this.props.location.search){
                const linkId = this.props.location.search.split("=").pop()
                if(linkId){
                    const reward = this.getCodeMoney(linkId).reward
                    this.setState({invitationReward: reward})
                }
            }
        } catch (error) {
            Aux.handleError(error)
        }
    }

    getCodeMoney = (code ) => {
        return promoCodes.find((element) => {
          return element.code === code;
        })
      }

    onSubmit = async () => {
        if (this.state.isLoading) {
            return;
        }

        this.setState({ isLoading: true, errorUsername: "", errorPassword:"", errorEmail:"" })
        try {
            if(!this.state.username){
                this.setState({errorUsername: "Can't be empty", isLoading:false})
                return;
            }else if(this.state.username.length < 5){
                this.setState({errorUsername: "Minimum 5 characters", isLoading:false})
                return;
            }else if(this.state.username.length > 30){
                this.setState({errorUsername: "Too long", isLoading:false})
                return;
            }else if(/[^a-zA-Z0-9._-]/gi.test(this.state.username)){
                this.setState({errorUsername: "Username can only have '.', '-' and '_'", isLoading:false})
                return;
            }else if(/[\s]/g.test(this.state.username)){
                this.setState({errorUsername: "Cant have empty spaces", isLoading:false})
                return;
            }

            if(!this.state.email){
                this.setState({errorEmail: "Can't be empty", isLoading:false})
                return;
            }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)) {
                this.setState({errorEmail: "Invalid email adress", isLoading:false})
                return;
            }

            if(!this.state.password){
                this.setState({errorPassword: "Can't be empty", isLoading:false})
                return;
            }else if(this.state.password.length < 6){
                this.setState({errorPassword: "Too shot", isLoading:false})
                return;
            }else if (/[\s]/g.test(this.state.password)) {
                this.setState({errorPassword: "Can't have empty spaces", isLoading:false})
                return;
            }

            let userAvailable = await Fire.shared.CheckIfUsernameExists(this.state.username.toLowerCase())
            if (!userAvailable) {
              this.setState({errorUsername: "Username already exists", isLoading:false})
              return;
            } else {
              const userData = {username: this.state.username, email: this.state.email, password : this.state.password}
              await Fire.shared.CreateUser(userData, this.state.invitationReward).then(didCreate => {
                if(didCreate){
                    this.props.history.push({
                        pathname: "/account/edit",
                        state: { addInfo: true }
                      })
                      return;
                }else {
                    this.setState({errorUsername: "An error has occurred, try again", isLoading:false})
                    return;
                }
                
              })
              this.setState({ isLoading: false })
              return;
            }
            
        } catch (error) {

            switch (error.code) {
                case 'auth/email-already-in-use':
                    this.setState({errorEmail: "Email already in use"})
                    break;
                case 'auth/weak-password':
                    this.setState({errorPassword: "Invalid Password"})
                    break;
                default:
                    break;
              }
            this.setState({ isLoading: false })
            Aux.handleError(error)
        }
    }

    goToLogin = () => {
        try{
            this.props.history.push("/account/login")
        }catch(error){
            Aux.handleError(error)
        }
    }

    loginSocial= async(isFacebook) => {
        if(this.state.facebookLoading || this.state.googleLoading || this.state.isLoading)
            return;
        try{
            
            if(isFacebook){
                this.setState({facebookLoading:true});
                await Fire.shared.loginFacebook().then(async(result) => {
                    if(result === "error"){
                        this.setState({facebookLoading:false, error: "An error has occurred"});
                        return;
                    }
                })
            } else{
                this.setState({googleLoading:true});
                await Fire.shared.loginGoogle().then(async(result) => {
                    if(result === "error"){
                        this.setState({googleLoading:false, error: "An error has occurred"});
                        return;
                    }
                })
            }
            await this.getUser();

            this.setState({googleLoading:false, facebookLoading: false});
           
        }catch(error){
            this.setState({googleLoading:false, facebookLoading: false ,error: "An error has occurred"});
            Aux.handleError(error)
        }
    }

    getUser = async() => {
        await Fire.shared.getUserData().then((didGetData) => {
            if(!didGetData){
                //this.props.myDataProvider.init();
               // this.setState({ isLoading: false, error: "You're not registered yet, please create an account" })
                this.props.history.push('/account/register/username')
            }else if(didGetData){
                if(didGetData.username){
                    this.props.myDataProvider.init();
                    this.setState({ isLoading: false })
                    this.props.history.push('/account/profile')
                }else{
                    this.props.history.push('/account/register/username')
                }
            }else{
                this.setState({ error: "An error has occurred, try again", isLoading: false })
            }
        });
    }

    onChanged(text) {
        //let num = text.replace(/[^0-9]/g, '')
        let username = text.replace(/[^a-zA-Z0-9-_.*$]/g, '')
        this.setState({
            username: username, errorUsername:""
        });
    }

    render() {
        //const error = this.state.error;
        const error = this.state.errorUsername || this.state.errorEmail || this.state.errorPassword || ""
        return (
            <div style={{width:"100%"}}>

                <section className="container">
                    {/* <img alt="logo" src={Aux.LogoImage} style={{ width: 50, objectFit: "contain" }}></img> */}
                    

                    <div>
                        <div style={{marginBottom:20}}>
                            <h2 style={{marginBottom:20}}>Register</h2>
                            <span style={{color:Colors.middleText}}>Create a free account and get <span style={{color:Colors.green, fontWeight:"bold"}}>20$!</span></span>
                            <div>
                            {/* <span style={{color:Colors.softText}}>Fill all the fields below to complete registering</span> */}
                            </div>
                        </div>
                        {/* {this.state.errorUsername ? <span className="login-error">{this.state.errorUsername}</span> : null}     */}
                        <ErrorMessage text={error}></ErrorMessage>
                        <TextInputMaterial maxLength={30} type="text" placeholder="Username" value={this.state.username}
                            style={{borderColor: this.state.errorUsername ? "red" : ""}}
                            onChange={(e) => {this.onChanged(e.target.value)}}
                        />
                        <TextInputMaterial maxLength={30} type="text" placeholder="Email" value={this.state.email}
                            style={{borderColor: this.state.errorEmail ? "red" : "", marginTop:15}}
                            onChange={(e) => {this.setState({ email: e.target.value });}}
                        />
                        <TextInputMaterial maxLength={30} type="password" placeholder="Password" value={this.state.password}
                            style={{borderColor: this.state.errorPassword ? "red" : "", marginTop:15}}
                            onChange={(e) => {this.setState({ password: e.target.value });}}
                        />
                        <ButtonLoader 
                            text="Register" 
                            loading={this.state.isLoading} 
                            style={{backgroundColor: Colors.red, width:"100%", height:45, marginTop:15}}
                            // icon={FacebookIcon}
                            onClick={this.onSubmit}
                        ></ButtonLoader>    

                    </div>

                     <div style={{display:"flex", justifyContent:"center"}}>
                            <span className="or-text" style={{marginTop:20}}>Or connect with </span>
                        </div>
                        
                        <div style={{display:"flex", marginTop:20, marginBottom:20, justifyContent:"space-between"}}>
                            
                            <ButtonLoader 
                                text="Facebook" 
                                loading={this.state.facebookLoading} 
                                style={{backgroundColor: Colors.facebook, height:45, width: "48%"}}
                                icon={FacebookIcon}
                                onClick={() => this.loginSocial(true)}
                            />

                            <ButtonLoader 
                                text="Google" 
                                loading={this.state.googleLoading} 
                                style={{backgroundColor: Colors.google, height:45, width: "48%",}}
                                icon={GoogleIcon}
                                onClick={() => this.loginSocial(false)}
                            />
                        </div>
                        <div style={{borderWidth: 0.1, borderColor:"#ccc", borderStyle:"solid", margin:"auto", marginTop:30, width:"70%", borderRadius:50}}/>
                        <div style={{display:"flex", justifyContent:"center",  marginTop:30}}>
                            <Link to={"/account/login"} style={{textDecoration:"none", textAlign:"center"}} className="text-hover"> 
                                <span style={{color:Colors.middleText}} >Already have an account?</span>
                                <span style={{marginLeft:5, color:Colors.mainColor}}  className="footer-text">Login</span>
                            </Link>
                        </div>
                </section>
            </div>
        );
    }
}

export default Register;